var map = {
	"./404Cat.jpg": 3761,
	"./IMG_5899.jpg": 697,
	"./MUILogo.png": 736,
	"./PythonLogo.png": 4617,
	"./REACT_Logo.png": 4065,
	"./TextFiles/SiteText": 9164,
	"./TextFiles/SiteText.json": 9164,
	"./VUE_Logo.png": 6741,
	"./VueSiteCode.png": 4220,
	"./github-mark-white.png": 7327,
	"./gmail.png": 7560,
	"./instagram.png": 4794,
	"./linkedin.png": 1654,
	"./twitter.png": 3220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;